/**
 * Theme Custom JS
 * Custom functionality for mettef.dk
 */

(function () {
  'use strict';

  /**
   * Gift Wrapping Handler
   */
  const GiftWrapping = {
    selectors: {
      productForm: 'product-form',
      productPage: 'product-page',
      giftCheckbox: '.gift-wrapping__checkbox:checked',
      cartForm: '#AjaxCartForm',
      cartSubtotal: '#AjaxCartSubtotal',
      cartCount: '[data-cart-count]',
      cartTotal: '[data-cart-total]',
      headerCartCount: '[data-header-cart-count]',
      headerCartTotal: '[data-header-cart-total]'
    },

    init() {
      const forms = document.querySelectorAll(this.selectors.productForm);
      console.log('[giftwrapping][init] Found forms:', forms.length);
      forms.forEach(form => {
        form.addEventListener('add-to-cart', this.onAddToCart.bind(this));
      });
    },

    onAddToCart(e) {
      const productPage = e.currentTarget.closest(this.selectors.productPage);
      const checkbox = productPage?.querySelector(this.selectors.giftCheckbox);
      const giftId = checkbox?.dataset.giftProductId;

      console.log('[giftwrapping][event]', { checkbox: !!checkbox, giftId });

      if (giftId) this.addToCart(giftId);
    },

    addToCart(id) {
      fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: `id=${id}&quantity=1`
      })
        .then(() => fetch('?section_id=helper-cart'))
        .then(res => res.text())
        .then(html => this.updateCart(html))
        .catch(err => console.error('[giftwrapping][error]', err));
    },

    updateCart(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newForm = doc.querySelector(this.selectors.cartForm);
      const newSubtotal = doc.querySelector(this.selectors.cartSubtotal);
      const cartForm = document.querySelector(this.selectors.cartForm);

      if (!cartForm || !newForm) return;

      cartForm.innerHTML = newForm.innerHTML;
      cartForm.ajaxifyCartItems?.();

      if (newSubtotal) {
        document.querySelector(this.selectors.cartSubtotal).innerHTML = newSubtotal.innerHTML;
      }

      // Update header
      const count = cartForm.querySelector(this.selectors.cartCount)?.textContent;
      const total = cartForm.querySelector(this.selectors.cartTotal)?.textContent;

      if (count) {
        document.querySelectorAll(this.selectors.headerCartCount).forEach(el => el.textContent = count);
      }
      if (total) {
        document.querySelectorAll(this.selectors.headerCartTotal).forEach(el => el.textContent = total);
      }
    }
  };

  /**
   * CUSTOM
   * Color Variants Handler
   * Finds products with same base name but different color suffix
   * and displays them as image thumbnails.
   */
  const ColorVariants = {
    init() {
      const container = document.querySelector('[data-color-variants]');
      if (!container) return;

      const baseName = container.dataset.baseName;
      const currentUrl = container.dataset.currentUrl;
      const currentColor = container.dataset.currentColor;
      const currentImage = container.dataset.currentImage;
      const currentTitle = container.dataset.currentTitle;
      const listContainer = container.querySelector('[data-color-variants-list]');

      if (!baseName || !listContainer) return;

      this.fetchVariants(baseName, currentUrl, currentColor, currentImage, currentTitle, listContainer, container);
    },

    fetchVariants(baseName, currentUrl, currentColor, currentImage, currentTitle, listContainer, container) {
      const query = encodeURIComponent(baseName);
      fetch(`/search/suggest.json?q=${query}&resources[type]=product&resources[limit]=10`)
        .then(response => {
          if (!response.ok) throw new Error(response.status);
          return response.json();
        })
        .then(data => {
          const products = data.resources?.results?.products || [];
          this.renderVariants(products, baseName, currentUrl, currentColor, currentImage, currentTitle, listContainer, container);
        })
        .catch(err => console.error('[color-variants][error]', err));
    },

    renderVariants(products, baseName, currentUrl, currentColor, currentImage, currentTitle, listContainer, container) {
      const colorPattern = /\(([^)]+)\)\s*$/;

      const variants = products.filter(product => {
        if (!product.title.startsWith(baseName)) return false;
        if (!colorPattern.test(product.title)) return false;
        if (product.url.split('?')[0] === currentUrl) return false;
        return true;
      });

      if (variants.length === 0) return;

      // Current product (active, no link)
      const currentItem = document.createElement('div');
      currentItem.className = 'product-color-variants__item';
      currentItem.innerHTML =
        '<span class="product-color-variants__link">' +
          (currentImage
            ? '<img src="' + currentImage + '" alt="' + currentTitle.replace(/"/g, '&quot;') + '" class="product-color-variants__image product-color-variants__image--active" loading="lazy">'
            : '') +
        '</span>';
      listContainer.appendChild(currentItem);

      // Other color variants as linked images
      variants.forEach(variant => {
        const match = variant.title.match(colorPattern);
        if (!match) return;

        const imageUrl = variant.featured_image?.url
          ? variant.featured_image.url.replace(/(\?|&)width=\d+/, '') + (variant.featured_image.url.includes('?') ? '&' : '?') + 'width=200'
          : '';

        const item = document.createElement('div');
        item.className = 'product-color-variants__item';
        item.innerHTML =
          '<a href="' + variant.url + '" class="product-color-variants__link">' +
            (imageUrl
              ? '<img src="' + imageUrl + '" alt="' + variant.title.replace(/"/g, '&quot;') + '" class="product-color-variants__image" loading="lazy">'
              : '<span class="product-color-variants__fallback">' + match[1] + '</span>') +
          '</a>';
        listContainer.appendChild(item);
      });

      container.style.display = '';
      this.initCarousel(container, listContainer);
    },

    initCarousel(container, listContainer) {
      const items = listContainer.querySelectorAll('.product-color-variants__item');
      if (items.length <= 4) return;

      // Place arrows inside the carousel (within overflow:hidden boundary)
      const carousel = container.querySelector('.product-color-variants__carousel');
      const arrowParent = carousel || container;

      const svgPrev = '<svg width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1L3 5L7 9" stroke="currentColor" stroke-width="1.5"/></svg>';
      const svgNext = '<svg width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 1L7 5L3 9" stroke="currentColor" stroke-width="1.5"/></svg>';

      const prevBtn = document.createElement('button');
      prevBtn.className = 'product-color-variants__arrow product-color-variants__arrow--prev product-color-variants__arrow--hidden';
      prevBtn.setAttribute('aria-label', 'Previous');
      prevBtn.innerHTML = svgPrev;

      const nextBtn = document.createElement('button');
      nextBtn.className = 'product-color-variants__arrow product-color-variants__arrow--next';
      nextBtn.setAttribute('aria-label', 'Next');
      nextBtn.innerHTML = svgNext;

      arrowParent.appendChild(prevBtn);
      arrowParent.appendChild(nextBtn);

      const getScrollDist = () => {
        const item = listContainer.querySelector('.product-color-variants__item');
        if (!item) return 100;
        const gap = parseFloat(getComputedStyle(listContainer).gap) || 0;
        return item.offsetWidth + gap;
      };

      const updateArrows = () => {
        const atStart = listContainer.scrollLeft <= 1;
        const atEnd = listContainer.scrollLeft + listContainer.clientWidth >= listContainer.scrollWidth - 1;
        prevBtn.classList.toggle('product-color-variants__arrow--hidden', atStart);
        nextBtn.classList.toggle('product-color-variants__arrow--hidden', atEnd);
      };

      prevBtn.addEventListener('click', () => {
        listContainer.scrollBy({ left: -getScrollDist(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        listContainer.scrollBy({ left: getScrollDist(), behavior: 'smooth' });
      });

      listContainer.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    }
  };

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      GiftWrapping.init();
      ColorVariants.init();
    });
  } else {
    GiftWrapping.init();
    ColorVariants.init();
  }

})();
